import { Icon, Badge, Grid, Box , ListItem , ListItemIcon } from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledBadge = styled(Badge)`
    top: 30;
    left: 85;
    width: 10;
    height: 15;
    background-color: red;
`

export const IconComponent = styled(Icon)`
    margin: 8px;
    color: ${props=> props.primary ? '#E3E3E3' : '#626262'};
    margin-left: ${props => props.inputMargin && '14px'};
`

export const ListItemContainer = styled(Grid)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: calc(100% - 152px);
    background-color: #424242;
`

export const ListItemComponent = styled(ListItem)`
    background-color: ${props => props.primary ? '#212121' : 'none'};
    height: 55px;
    &:hover {
        background-color: ${props => props.primary ? '#212121' : 'rgba(178,178,178,0.2)'};
    }
`

export const ListItemBorder = styled(Box)`
    position: absolute;
    width: 6px;
    border-top: 55px solid ${props => props.primary ? 'RGB(220, 198, 183)' : '#424242'} ;
`

export const ListItemIconContainer = styled(ListItemIcon)`
    min-width: 0;
`

export const SubItemIconSpacer = styled(Box)`
    width: 40px;
    flex-shrink: 0;
`